module.exports = __webpack_public_path__ + "media/src/images/web/web-header-96d41d5f5ee41d5cfcfb0405d5269a9b.svg";